import styled from 'styled-components';

import {colors} from 'theme';

export const ButtonsContainer = styled.div`
    display: flex;
    align-items: flex-end;
    padding-top: 20px;
`;

export const FilterIconCross = styled.span`
    svg {
        float: right;
        display: block;
        width: 12px;
        cursor: pointer;
        padding-top: 2px;
    }
`;

export const FilterContainer = styled.div`
    width: 330px;
    background: rgb(255, 255, 255);
    box-shadow: 0 1px 13px rgba(0, 0, 0, 0.1);
    position: absolute;
    padding: 12px 20px 20px 20px;
    box-sizing: border-box;
    top: 0;
    left: 0;
    z-index: 1;
    transition: all 1s linear;
    &.visible {
        visibility: visible;
        display: block;
        opacity: 1;
        transition: opacity 0.15s linear;
    }
    &.hidden {
        visibility: hidden;
        display: none;
        opacity: 0;
        transition: visibility 0s 0.15s, opacity 0.15s linear;
    }
`;

export const FilterTitle = styled.div`
    font-size: 12px;
    margin-bottom: 23px;
`;

export const FilterIconContainer = styled.div<{active: boolean}>`
    display: inline-block;
    margin-left: 10px;
    background-color: ${(props) => (props.active ? colors.brandPrimary : '')};
    padding: 6px 6px 4px 6px;
    border-radius: 20px;
    cursor: pointer;
    & > svg {
        fill: ${(props) => (props.active ? '#fff' : colors.black)};
    }
`;
